.title {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    padding: 0.8rem 1rem;
}

.cardBody {
    padding: 1rem;
    width: 50%;
}

.formField {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    margin-bottom: 1rem;
}

.fieldLabel {
    font-size: 0.875rem;
    font-weight: 500;
    color: #334155; // slate-700
}

.fieldInput {
    height: 2.5rem;
    padding: 0 0.875rem;
    font-size: 0.875rem;
    border: 1px solid #90A1B9; 
    border-radius: 0.5rem; 
    background-color: #F9FAFB; 
    color: #334155; 
    outline: none;
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &::placeholder {
        color: #94a3b8; // slate-400
    }

    &:focus {
        border-color: #3b82f6; // blue-500
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
    }
}

.passwordInputWrap {
    position: relative;
}

.fieldInputWithToggle {
    padding-right: 2.5rem;
}

.passwordToggleBtn {
    position: absolute;
    top: 50%;
    right: 0.625rem;
    transform: translateY(-50%);
    border: 0;
    background: transparent;
    color: #64748b;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    line-height: 1;
}

.errorText {
    font-size: 0.75rem;
    color: #ef4444; // red-500
    margin-top: 0.25rem;
}

.formActions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding-top: 3rem;
}

.cnloutlineCustom {
  border: 1px solid #90A1B9;
}